<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Demo' | translate"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>


      @if (loaded) {
        <tidy-row>
          <tidy-text [title]="'Title' | translate" />
        </tidy-row>
        <tidy-row>
          <tidy-text [header]="'Header' | translate" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="'Body' | translate" />
        </tidy-row>
        <tidy-row>
          <tidy-text [helper]="'Helper' | translate" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="companyName"
            [form]="form.controls.companyName"
            [label]="'Input label' | translate"
            [submitted]="submitted"
            [icon]="'assets/svg/information-circle.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-textarea
            formControlName="textarea"
            [form]="form.controls.textarea"
            [label]="'Textarea label' | translate"
            [icon]="'assets/svg/chatbubble.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input-international-phone
            formControlName="phone"
            [label]="'Phone' | translate"
            [form]="form.controls.phone"
            [inputMode]="'numeric'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid phone.' | translate"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }"
            (countryCodeChange)="onCountryCodeChange($event)" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            formControlName="select"
            [form]="form.controls.select"
            [label]="'Select label' | translate"
            [items]="selectItems"
            [icon]="'assets/svg/list.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            formControlName="select"
            [form]="form.controls.select"
            [label]="'Select label (multiple)' | translate"
            [items]="selectItems"
            [icon]="'assets/svg/list.svg'"
            [multiple]="true" />
        </tidy-row>
        <tidy-row>
          <tidy-auto-complete
            formControlName="autocomplete"
            [form]="form.controls.autocomplete"
            [label]="'Autocomplete label' | translate"
            [options]="autocompleteItems"
            [icon]="'assets/svg/search.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-datepicker
            formControlName="datepicker"
            [form]="form.controls.datepicker"
            [label]="'Datepicker label' | translate"
            [icon]="'assets/svg/calendar.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="inputEmpty"
            [form]="form.controls.inputEmpty"
            [label]="'Input label' | translate"
            [submitted]="submitted"
            [icon]="'assets/svg/information-circle.svg'"
            [helperText]="'Input helper'" />
        </tidy-row>
        <tidy-row>
          <tidy-textarea
            formControlName="textareaEmpty"
            [form]="form.controls.textareaEmpty"
            [label]="'Textarea label' | translate"
            [icon]="'assets/svg/chatbubble.svg'"
            [helperText]="'Textarea helper'" />
        </tidy-row>
        <tidy-row>
          <tidy-input-international-phone
            formControlName="phoneEmpty"
            [label]="'Phone' | translate"
            [form]="form.controls.phoneEmpty"
            [inputMode]="'numeric'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid phone.' | translate"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }"
            [helperText]="'(458) 555-1234'"
            (countryCodeChange)="onCountryCodeChange($event)" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            formControlName="selectEmpty"
            [form]="form.controls.selectEmpty"
            [label]="'Select label' | translate"
            [items]="selectItems"
            [icon]="'assets/svg/list.svg'"
            [helperText]="'Select helper'" />
        </tidy-row>
        <tidy-row>
          <tidy-auto-complete
            formControlName="autocompleteEmpty"
            [form]="form.controls.autocompleteEmpty"
            [label]="'Autocomplete label' | translate"
            [options]="autocompleteItems"
            [icon]="'assets/svg/search.svg'"
            [helperText]="'Autocomplete helper'" />
        </tidy-row>
        <tidy-row>
          <tidy-datepicker
            formControlName="datepickerEmpty"
            [form]="form.controls.datepickerEmpty"
            [label]="'Datepicker label' | translate"
            [icon]="'assets/svg/calendar.svg'"
            [helperText]="'Datepicker helper'" />
        </tidy-row>
        <tidy-row>
          <tidy-radio-button
            formControlName="radio"
            [form]="form.controls.radio"
            [label]="'Radio label' | translate"
            [items]="radioItems" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Checkbox label' | translate" />
        </tidy-row>
        <tidy-row>
          <tidy-checkbox
            [items]="checkboxItems" />
        </tidy-row>
        <tidy-button
          [text]="'Primary Button' | translate"
          [action]="boundSave"
          class="primary" />
        <tidy-button
          [text]="'Secondary Button' | translate"
          class="secondary" />
        <tidy-row>
          <tidy-alert class="yellow-background">
            <tidy-text [body]="'Yellow alert' | translate" />
          </tidy-alert>
        </tidy-row>
        <tidy-row>
          <tidy-alert class="green-background">
            <tidy-text [body]="'Green alert' | translate" />
          </tidy-alert>
        </tidy-row>
        <tidy-row>
          <tidy-alert class="light-green-background">
            <tidy-text [body]="'Light green alert' | translate" />
          </tidy-alert>
        </tidy-row>
        <tidy-row>
          <tidy-alert class="red-background">
            <tidy-text [body]="'Red alert' | translate" />
          </tidy-alert>
        </tidy-row>
        <tidy-row>
          <tidy-alert class="grey-background">
            <tidy-text [body]="'Grey alert' | translate" />
          </tidy-alert>
        </tidy-row>
        <tidy-row>
          <tidy-alert class="blue-background">
            <tidy-text [body]="'Blue alert' | translate" />
          </tidy-alert>
        </tidy-row>
        <tidy-error-message [text]="errorMessage | translate" />
      }

    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
